import type { Meta, StoryObj } from "@storybook/react";

import type { BookingOptionCardProps } from "@/ui/components/schedule/booking/BookingOptionCard";
import BookingOptionCard from "@/ui/components/schedule/booking/BookingOptionCard";

const StoryMeta: Meta<BookingOptionCardProps> = {
  title: "Components/Schedule/Booking/Booking Option Card",
  component: BookingOptionCard,
  argTypes: {
    id: { control: "text" },
    infoLabel: { control: "text" },
    isSelected: { control: "boolean" },
    onSelect: { action: "selected" },
    title: { control: "text" },
  },
  args: {
    id: "booking-option-card",
    isSelected: false,
    title: "Recurring weekly",
  },
};

type Story = StoryObj<BookingOptionCardProps>;
const Primary: Story = {};
const Selected: Story = {
  args: {
    isSelected: true,
  },
};

const WithInfo: Story = {
  args: {
    infoLabel:
      "Please note, recurring appointments will be booked for 6 months",
  },
};

export default StoryMeta;
export { Primary, Selected, WithInfo };
